import { Component, Input, OnInit } from '@angular/core';

import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { ToasterService } from '@frontend/sports/toaster/feature';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { ClipboardService } from '@frontend/vanilla/shared/clipboard';

import { EpcotConfigService } from '../../../common/epcot-config.service';
import { MyBetsListContext, MyBetsSlipEditBetHistoryViewModel } from '../../../my-bets-base/models/my-bets-viewmodels';

@Component({
    selector: 'ms-my-bets-edit-bet-history-betslip',
    templateUrl: 'my-bets-edit-bet-history-betslip.html',
    standalone: false,
})
export class MyBetsEditBetHistoryBetslipComponent implements OnInit {
    @Input() betslip: MyBetsSlipEditBetHistoryViewModel;
    @Input() myBetsListContext: MyBetsListContext;
    @Input() isFirst: boolean;
    collapsed: boolean;
    isEpcotEnabled: boolean;

    constructor(
        private clipboardService: ClipboardService,
        private toaster: ToasterService,
        private tracker: TrackingService,
        public sitecoreMyBets: SitecoreMyBetsConfig,
        private epcotConfigService: EpcotConfigService,
    ) {
        this.isEpcotEnabled = this.epcotConfigService.isEnabled();
    }

    ngOnInit(): void {
        this.collapsed = this.isFirst ? false : true;
    }

    toggleClick(): void {
        this.collapsed = !this.collapsed;
    }

    get betslipId(): string {
        return this.betslip.editBetHistory[0].betSlipNumber;
    }

    copyToClipboard(event: Event): void {
        event.stopPropagation();
        event.preventDefault();

        if (this.clipboardService.copy(this.betslipId)) {
            this.toaster.open(this.sitecoreMyBets.myBets.BetSlipIdCopied, { duration: 3000 });
        } else {
            this.toaster.open('copy NOT supported!', { duration: 3000 });
        }

        const context = this.myBetsListContext.isEventView ? 'EventView' : 'myBets';
        this.tracker.update({ [trackingConstants.PAGE_REFERRING_ACTION]: context + '_BetIDCopy' });
    }
}
